import { useContext } from 'react';

import PlatformSettingsContext from './PlatformSettingsContext';

function usePlatformSettings() {
  const context = useContext(PlatformSettingsContext);

  if (context === undefined) {
    throw new Error(
      'usePlatformSettings must be used inside PlatformSettingsProvider.',
    );
  }

  return context;
}

export default usePlatformSettings;
